<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="23.3684" cy="23.3684" r="8.21053" fill="#1368D7" id="ripple"/>
    <circle cx="23.3684" cy="23.3684" r="7.57895" fill="#1368D7" stroke="white" stroke-width="1.26316"/>
  </svg>
</template>
